import { Component, Input } from '@angular/core';
import { Pedido } from '../../../core/models/pedidos/pedido';

/**
 * Lista de pedidos pendência vinculados a este pedido, mostrada ao editar um pedido
 * existente que já gerou pendências (pedidos-cadastro.component.html:1232-1256). Read-only.
 *
 * Gate de visibilidade (usaPendencia && pedidosPendencia && pedidosPendencia.length > 0)
 * fica no PAI, mesmo padrão da Task 3.
 */
@Component({
  selector: 'app-pedidos-pendencia-vinculados',
  standalone: false,
  templateUrl: './pedidos-pendencia-vinculados.component.html',
  styleUrls: ['./pedidos-pendencia-vinculados.component.scss']
})
export class PedidosPendenciaVinculadosComponent {
  @Input() pedidosPendencia: Pedido[] = [];
}
